import { NgClass, isPlatformBrowser } from '@angular/common';
import {
  Component,
  HostListener,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  PLATFORM_ID,
  DOCUMENT,
  signal,
} from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { ProgramI } from '../../interfaces/program.interface';
import { SIDE_MENU_ITEMS } from './constants/side-menu.constant';
import { SecondarySideMenuI } from '../../../../shared/interfaces/secondary-side-menu.interface';

@Component({
  selector: 'app-programs-details-side-menu',
  imports: [TranslateModule, NgClass, RouterLink],
  templateUrl: './programs-details-side-menu.component.html',
  styleUrl: './programs-details-side-menu.component.scss',
})
export class ProgramsDetailsSideMenuComponent implements OnInit, OnDestroy {
  constructor(
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private readonly platformID: Object,
    private readonly router: Router
  ) {}

  @Input('selectedProgram') selectedProgram?: ProgramI;
  private readonly destroy$ = new Subject<void>();
  sideMenuItems = SIDE_MENU_ITEMS;
  isSideMenuOpen = signal<boolean>(false);

  ngOnInit(): void {
    this.initScreenType();
  }

  public getSideMenuItemIcon(sideMenuItem: SecondarySideMenuI) {
    return this.router.url ===
      '/' + sideMenuItem.route(this.selectedProgram?._id ?? '')
      ? sideMenuItem.activeIcon
      : sideMenuItem.nonActiveIcon;
  }

  public isCurrentRouteActive(sideMenuItem: SecondarySideMenuI) {
    if (sideMenuItem.alt === 'Home') {
      return this.router.url?.trim() === '' || this.router.url === 'home';
    } else {
      return (
        this.router.url ===
        '/' + sideMenuItem.route(this.selectedProgram?._id ?? '')
      );
    }
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event & { target: { innerWidth: number } }) {
    this.isSideMenuOpen.update(
      () => event.target?.innerWidth <= 700 && event.target?.innerWidth >= 500
    );
  }

  initScreenType() {
    if (isPlatformBrowser(this.platformID)) {
      this.isSideMenuOpen.update(
        () =>
          this.document.defaultView!.innerWidth <= 700 &&
          this.document.defaultView!.innerWidth >= 500
      );
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
